export interface PollingTriggerLogger {
  info(message: string): void;
  warn(message: string): void;
  error(message: string, exception?: Error): void;
  debug(message: string): void;
}

export class NoOpPollingTriggerLogger implements PollingTriggerLogger {
  info(): void {}
  warn(): void {}
  error(): void {}
  debug(): void {}
}
